import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { ProductIntroSection } from './ProductIntroSection';
import { IncludesSection } from './IncludesSection';
import { BenefitsSection } from './BenefitsSection';
import { TestimonialsSection } from './TestimonialsSection';
import { BonusSection } from './BonusSection';
import { PricingSection } from './PricingSection';
import { GuaranteeSection } from './GuaranteeSection';
import { FAQSection } from './FAQSection';
import { PurchasePopup } from './PurchasePopup';
import { useMetaPixel } from '../hooks/useMetaPixel';
const META_PIXEL_ID = '1904779843432668';
export function LandingPage() {
  // Initialize Meta Pixel with PageView tracking
  useMetaPixel(META_PIXEL_ID);
  return <main className="min-h-screen bg-[#FDF6E3] font-sans text-gray-900" data-id="element-129">
      <HeroSection data-id="element-130" />
      <ProblemSection data-id="element-131" />
      <SolutionSection data-id="element-132" />
      <ProductIntroSection data-id="element-133" />
      <IncludesSection data-id="element-134" />
      <BenefitsSection data-id="element-135" />
      <BonusSection data-id="element-136" />
      <PricingSection data-id="element-137" />
      <GuaranteeSection data-id="element-138" />
      <TestimonialsSection data-id="element-139" />
      <FAQSection data-id="element-140" />

      <footer className="bg-[#1e3a5a] text-white py-8 text-center text-sm" data-id="element-141">
        <div className="max-w-7xl mx-auto px-4" data-id="element-142">
          <p data-id="element-143">
            &copy; {new Date().getFullYear()} Política y Ciudadanía 360. Todos
            los derechos reservados.
          </p>
          <p className="mt-2 text-blue-300" data-id="element-144">
            Diseñado para docentes argentinos.
          </p>
        </div>
      </footer>

      <PurchasePopup data-id="element-145" />
    </main>;
}